import { jsxs as c, jsx as e, Fragment as v } from "react/jsx-runtime";
import { useState as A, useRef as j, useEffect as b } from "react";
function x({
  submenuId: s,
  items: o,
  isActive: d,
  isTouchEnabled: l,
  setActiveSubmenu: a
}) {
  var t;
  const [i, r] = A((t = o[0]) == null ? void 0 : t.submenuId);
  return /* @__PURE__ */ c(
    "div",
    {
      id: s,
      className: `ajb-main-menu-submenu-content ${d ? "show" : ""}`,
      children: [
        o[0].links && /* @__PURE__ */ e("div", { className: "submenu-section", children: /* @__PURE__ */ e("nav", { className: "main-nav-persistent", children: /* @__PURE__ */ e("ul", { className: "menubar-persistent", children: o.map((n, m) => {
          if (n.links)
            return /* @__PURE__ */ c("li", { children: [
              /* @__PURE__ */ c(
                "button",
                {
                  "data-submenu": `${n.submenuId}${l ? "Mobile" : ""}`,
                  "aria-haspopup": "true",
                  "aria-expanded": i === n.submenuId,
                  className: `btn-primary desktop-sub-menu ${i === n.submenuId ? "is-active" : ""}`,
                  onClick: () => r(n.submenuId),
                  onMouseEnter: l ? void 0 : () => r(n.submenuId),
                  children: [
                    n.category,
                    /* @__PURE__ */ e(
                      "svg",
                      {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 320 512",
                        "aria-hidden": "true",
                        focusable: "false",
                        role: "img",
                        children: /* @__PURE__ */ e("path", { d: "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" })
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ c(
                "button",
                {
                  "data-submenu": `${n.submenuId}Mobile`,
                  "aria-haspopup": "true",
                  "aria-expanded": i === n.submenuId,
                  className: `mobile-sub-menu mobile-sub-menu-trigger is-touch-enabled ${i === n.submenuId ? "is-active" : ""}`,
                  onClick: () => r(
                    i === n.submenuId ? null : n.submenuId
                  ),
                  children: [
                    n.category,
                    /* @__PURE__ */ e("span", { className: "icon-accordion", children: /* @__PURE__ */ e(
                      "svg",
                      {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 512 512",
                        "aria-hidden": "true",
                        focusable: "false",
                        role: "img",
                        children: /* @__PURE__ */ e("path", { d: "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" })
                      }
                    ) })
                  ]
                }
              ),
              /* @__PURE__ */ e(
                "div",
                {
                  id: `${n.submenuId}Mobile`,
                  className: `ajb-main-menu-submenu-content-persistent mobile-sub-menu ${i === n.submenuId && l ? "show" : ""}`,
                  children: /* @__PURE__ */ e("div", { className: "submenu-section-persistent", children: /* @__PURE__ */ c(
                    "div",
                    {
                      className: `ajb-main-menu-submenu-section-wrapper ${n.features ? "has-menu-features" : ""}`,
                      children: [
                        /* @__PURE__ */ e("div", { className: "submenu-section ajb-main-menu-list-item-links", children: /* @__PURE__ */ e("ul", { children: n.links && n.links.map((u, h) => /* @__PURE__ */ e("li", { children: /* @__PURE__ */ c(
                          "a",
                          {
                            className: "ajb-main-nav-link",
                            href: u.href,
                            children: [
                              /* @__PURE__ */ e("span", { className: "ajb-main-nav-link-title", children: u.title }),
                              /* @__PURE__ */ e("p", { className: "ajb-helper-text", children: u.desc })
                            ]
                          }
                        ) }, h)) }) }),
                        n.features && /* @__PURE__ */ e("div", { className: "submenu-section ajb-main-menu-list-item-features", children: /* @__PURE__ */ e("ul", { children: n.features.map((u, h) => /* @__PURE__ */ e(
                          "li",
                          {
                            className: "ajb-main-nav-menu-features",
                            children: /* @__PURE__ */ c("a", { href: u.href, children: [
                              /* @__PURE__ */ e("svg", {}),
                              /* @__PURE__ */ c("span", { className: "ajb-main-nav-menu-features-content", children: [
                                /* @__PURE__ */ e("p", { className: "ajb-main-nav-link-title", children: u.title }),
                                /* @__PURE__ */ e("p", { className: "ajb-helper-text", children: u.desc })
                              ] })
                            ] })
                          },
                          h
                        )) }) })
                      ]
                    }
                  ) })
                }
              )
            ] }, m);
        }) }) }) }),
        !o[0].links && /* @__PURE__ */ e("div", { className: "ajb-main-menu-submenu-section-wrapper", children: /* @__PURE__ */ e("div", { className: "submenu-section ajb-main-menu-list-item-links", children: /* @__PURE__ */ e("ul", { children: o.map((n, m) => /* @__PURE__ */ e("li", { children: /* @__PURE__ */ c("a", { className: "ajb-main-nav-link", href: n.href || "#", children: [
          /* @__PURE__ */ e("span", { className: "ajb-main-nav-link-title", children: n.category }),
          /* @__PURE__ */ e("p", { className: "ajb-helper-text", children: n.desc })
        ] }) }, m)) }) }) }),
        o.map((n, m) => n.links && /* @__PURE__ */ e(
          "div",
          {
            id: `${n.submenuId}`,
            className: `ajb-main-menu-submenu-content-persistent desktop-sub-menu ${i === n.submenuId ? "show" : ""}`,
            children: /* @__PURE__ */ e("div", { className: "submenu-section-persistent", children: /* @__PURE__ */ c(
              "div",
              {
                className: `ajb-main-menu-submenu-section-wrapper ${n.features ? "has-menu-features" : ""}`,
                children: [
                  /* @__PURE__ */ e("div", { className: "submenu-section ajb-main-menu-list-item-links", children: /* @__PURE__ */ e("ul", { children: n.links && n.links.map((u, h) => /* @__PURE__ */ e("li", { children: /* @__PURE__ */ c("a", { className: "ajb-main-nav-link", href: u.href, children: [
                    /* @__PURE__ */ e("span", { className: "ajb-main-nav-link-title", children: u.title }),
                    /* @__PURE__ */ e("p", { className: "ajb-helper-text", children: u.desc })
                  ] }) }, h)) }) }),
                  n.features && /* @__PURE__ */ e("div", { className: "submenu-section ajb-main-menu-list-item-features", children: /* @__PURE__ */ e("ul", { children: n.features.map((u, h) => /* @__PURE__ */ e(
                    "li",
                    {
                      className: "ajb-main-nav-menu-features",
                      children: /* @__PURE__ */ c("a", { href: u.href, children: [
                        /* @__PURE__ */ e(
                          "div",
                          {
                            dangerouslySetInnerHTML: {
                              __html: u.icon
                            }
                          }
                        ),
                        /* @__PURE__ */ c("span", { className: "ajb-main-nav-menu-features-content", children: [
                          /* @__PURE__ */ e("p", { className: "ajb-main-nav-link-title", children: u.title }),
                          /* @__PURE__ */ e("p", { className: "ajb-helper-text", children: u.desc })
                        ] })
                      ] })
                    },
                    h
                  )) }) })
                ]
              }
            ) })
          },
          `smcat-${m}`
        ))
      ]
    }
  );
}
function y({ label: s, submenu: o, isActive: d, onClick: l }) {
  return /* @__PURE__ */ c(
    "button",
    {
      "data-submenu": o,
      className: `mobile-${s === "Account" ? "account-" : ""}menu-trigger ${d ? "is-active" : ""}`,
      "aria-haspopup": "true",
      "aria-expanded": d,
      onClick: l,
      children: [
        /* @__PURE__ */ c("span", { className: "open-mobile-menu", children: [
          s === "Account" && /* @__PURE__ */ e("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", children: /* @__PURE__ */ e(
            "path",
            {
              fill: "currentcolor",
              d: "M399 384.2C376.9 345.8 335.4 320 288 320l-64 0c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"
            }
          ) }),
          s === "Menu" && /* @__PURE__ */ e("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512", children: /* @__PURE__ */ e(
            "path",
            {
              fill: "currentcolor",
              d: "M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"
            }
          ) }),
          s
        ] }),
        /* @__PURE__ */ c("span", { className: "close-mobile-menu", children: [
          /* @__PURE__ */ e("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 384 512", children: /* @__PURE__ */ e("path", { d: "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" }) }),
          "Close"
        ] })
      ]
    }
  );
}
function L({
  item: s,
  isTouchEnabled: o,
  setActiveSubmenu: d,
  activeSubmenu: l,
  isLoggedIn: a
}) {
  const i = j(null);
  b(() => {
    if (i.current === null || !i.current.classList.contains("is-active"))
      return;
    const t = document.querySelector(
      ".ajb-main-nav-submenu-container"
    ), n = i.current.getBoundingClientRect(), m = t.parentElement.getBoundingClientRect(), u = t.querySelector(".ajb-main-menu-pointer"), h = 32;
    t.style.width = "", t.style.right = "auto", t.classList.remove("is-right");
    let f = t.getBoundingClientRect(), p;
    i.current.closest(".ajb-main-nav-last-item") ? (t.style.width = "70%", t.classList.add("is-right"), f = t.getBoundingClientRect(), p = window.innerWidth - f.width - h) : (p = n.left + n.width / 2 - f.width / 2, p = Math.max(
      h,
      Math.min(p, window.innerWidth - f.width - h)
    ));
    const N = p - m.left, B = n.bottom - m.top;
    if (t.style.left = `${N}px`, t.style.top = `${B}px`, u) {
      const z = n.left + n.width / 2 - p, I = u.getBoundingClientRect().width, Q = f.width - I;
      u.style.left = `${Math.max(0, Math.min(z, Q))}px`;
    }
    t.classList.add("show-opaque"), setTimeout(() => {
      t.classList.add("show");
    }, 10);
  }, [l]);
  const r = (t) => new Promise((n) => {
    d(s.submenu), n();
  });
  return s.isLastItem && !a ? null : /* @__PURE__ */ e("li", { className: s.isLastItem ? "ajb-main-nav-last-item" : "", children: s.hasSubmenu ? /* @__PURE__ */ e(
    "button",
    {
      ref: i,
      "data-submenu": s.submenu,
      "aria-haspopup": "true",
      "aria-expanded": l === s.submenu,
      className: `btn-primary ${l === s.submenu ? "is-active" : ""} ${s.isLastItem ? "my-account" : ""}`,
      onMouseEnter: async () => {
        o || await r();
      },
      onClick: o ? r : void 0,
      onKeyDown: (t) => {
        (t.key === "Enter" || t.key === "ArrowDown") && r(), t.key === "Escape" && d(null);
      },
      onMouseLeave: (t) => {
        (t.relatedTarget.classList && t.relatedTarget.classList.contains("ajb-main-nav") || t.relatedTarget.classList && t.relatedTarget.classList.contains("leading-group")) && setTimeout(() => {
          l === s.submenu && d(null);
        }, 40);
      },
      children: s.isLastItem ? /* @__PURE__ */ c("span", { className: "my-account-button", children: [
        /* @__PURE__ */ c("span", { className: "my-account-icon", children: [
          " ",
          /* @__PURE__ */ e(
            "svg",
            {
              "aria-hidden": "true",
              focusable: "false",
              role: "img",
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 512 512",
              children: /* @__PURE__ */ e("path", { d: "M399 384.2C376.9 345.8 335.4 320 288 320l-64 0c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z" })
            }
          )
        ] }),
        s.label
      ] }) : /* @__PURE__ */ c(v, { children: [
        /* @__PURE__ */ e("span", { className: "mobile-icon-back", children: /* @__PURE__ */ e(
          "svg",
          {
            "aria-hidden": "true",
            focusable: "false",
            role: "img",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 320 512",
            children: /* @__PURE__ */ e("path", { d: "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" })
          }
        ) }),
        s.label,
        /* @__PURE__ */ e("span", { className: "mobile-icon-forward", children: /* @__PURE__ */ e(
          "svg",
          {
            "aria-hidden": "true",
            focusable: "false",
            role: "img",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 320 512",
            children: /* @__PURE__ */ e("path", { d: "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" })
          }
        ) })
      ] })
    }
  ) : /* @__PURE__ */ e(
    "a",
    {
      href: s.href,
      className: "ajb-main-nav-link ajb-main-nav-btn-link",
      onMouseEnter: () => d(null),
      children: s.label
    }
  ) });
}
const S = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZAAAAB/CAMAAAD2BGQdAAAABGdBTUEAALGPC/xhBQAAAwBQTFRFR3BMNzdBNTVANzdBODhANzdANjZBNjZANzdBODhAODhANzdBNjZANzdBNzdBNzdBQkJC1QAxjEVaAAAANTVAJiYqKioq1gAyOTlALCxANjZBNTU9NzdBODhBMzM7NzdANzdB1gAy3AAsODhA1QAxNzdBNjZBNzdB1QAyNzdBNzdCNjZA1gAy1gAy/wAANzdBNzdB1gAxNzdANzdA1gAyODg/1gAyMzMzNzdBNzdANTVBNjZB1gAwNzdB1QAyNzdB1AAxNzdBOjpB1QAxNzdBNzdBNzdB1gA01gAy1gAwNzdBNjZB1QAyNjZBODhANjZB1gAmqgBVNjZANzdBNzdB1gAxODhB1QAyNzdA1QAy1QAy1gAx3QA0zgAsNzdBNzdA1QAyNzdBNzdA1QAyNzdB4wBANjZBNjZBMzNE1AAyNzdC1gAy1gAy1QAs1wAz1QAq1QAy1QA01QAyNjZANzdB1gAyNzdBNzdBODhC1gAxNzdA1QAx1gAxNzdB1gAyNjZBNzdA1QAyNjZANjZBODhANzdB1AAx1QAy1gAy1QAyNzdB1QAy2QAvNzdB1QAxNjY/NzdB1QAyNjZBzAAz1QAxNzdANjZA1QAyNjZBOTlANzdB1QAx1QAz1QAy1gAy1QAy1QAxNzdBODhBNzdB1gAxNjZB1QAy1QAyNzdB1QAy1QAy1gAy1AAx1QAy2wAk1QAy1QAw1QAy1QAx1QAy1AAw1gAy1gAzNzdB1gAy0wAwNjZBNjZANzdBODhBNzdBNzdC1QAy1QAy1gAx1gAy1QAx1gAy1QAy1QAx1AAx1gAyNzdB1QAyNzdANzdBNjZBNzdB1QAyNjZBNzdBNzdB1QAx1QAx1QAx1AAz1QAy1QAy1AAy1QAy1QAy1gAy1QAx1gAxNDRCODhB1gAxNzdB1gAyNzdB1QAw0wAu1QAyODhC1QAyODhCNzdA1gAx1wAySUlJ1QAy1QAx1QAx3gAs1gAy1QAy1AAy1QA11gAy1gAy1gAy0wAx1AAzOTk+NzdB1QAy+lQULgAAAP50Uk5TAM8Y90CvoFDfIJ+//mD89gP+AgEwBwb3MAhDFGgmCjf6/AgP0OXr2vvJGzqvqAGKsb/Xk/EQ5wXEgjPwP7X6exNdIdqd8rog4ULHRVNMgG0KA1pIzd/4uO856f0ODaWRi5zncHAEluENdN2ZLRgQBnkiXS3t5pnkHh1ObRk1hI1kyMvmI6JQ3eqgt8sLqH8peWbBBdbPqo1UGVeCJPA8kmjUPX60hs9z0orsShudBzI3WIcnYMZ26UgeFnJSd60nwpRa0kW+9flMkGKtZbOndbO93o7tt5g+TsQv+WI1JXwSwdqh1bwrF1dr4yvivGcHVO4pF9mjazC6pZY8ZFq67wT7AAATo0lEQVR42u2deXwURRaAW4iSGDI5BqJJIAlkIQfkAkICwpKEm3DIaQC55DAiAgECCIZDuYMcIrccIoRDLkEOAwoCG9GgeCFK0GV38UZXWVxdd3d60/er7qrumqHTM+yv3z+QrurqnvfNVL336lUVw9y+fP5vxhZfkrAj/7SV4FOyjJ1oK8GXJPu+0LUTbDX4kPzC2r8Rn5KDLMv+2VaDNVI46Vy2YaUuVUQm2bqyiMi+t85WfDNEt86WKiBFXW1dWSQLFrFsZXKb3uQa56qAsF1es1VllRlVwSn8u6PjSRX29+cq/GBryjLfbxmncLboxwcJFRbz5TttTVkmP23iVX79PL74U7508GZbUZbJwEG8ztkKrM21twVfmN7QVpRlcrO/QOTWAkxhymm+LPSorSfrpLPQa7EJKzGFbwplg2xLy8rfiNhrsYu1Y/tWseh3W00WSptyicjD6qIDYsl9T9lqMltSGu4nFf0zVNT7abXnPjpBLPnEVqB5Mn7zzN//dLZ/y6L+pdvf/s8VTEh9lqh29l/qkj+IBYPtn4hJcmX3b3tYRAZVzDysqtRQ0ju7BesaVslaW5UmSMOrt1icNNj+cgpS8YUWUtE3aAsTpeu3ltrqvF35+s9dWKKU/IggmSRdX3QFdeXlG36yFXp7surMd6yulHwOq5fKPwVkYB8nV//NVunt+Xu/DebUWN7lD6Wlpf3LcUT+uBvESz6XOy1k2jZbrl3+pK3U25AF5W99dujVX2XH4uuBV38vSVAjKS3UOOUsW/kFbOgtufJM5AG0Q8q8WpL4UdUvqIWVMqTS97UMxC9meZnTdKX21T5om1wYoy3sodzadfh5TEDwqTNb2qNEfn5FLnxCckbYdHiP0u8lo95kZ7oPkeaS5FgG1Yd2YaUOrBPSz0Uhwc3enV0vJsI8HkmYh9wtFZZN0Rb6K/cSpwEbnnu/AWJvPSYXfSJfhLO2ZxV4KBC6WZJ5scr71aK5YSoFkPtru6jlmWf7ZpoEpJUekHdcukD05Iu3WwIig5dJ15+UB5pLYUrtz5Sq4xAgpftpHhYE3i+Non741LTAwH6NHLpAcgIDs1bfiKVl4n8xyRQguX7revVMy8cDSdp28kK7oTc8AVLVOw0Ho0mo3Gvtk0eRgUrdS0rNkbCN4w0O0jwqC7zfFPpePTxmhA4QQZz1ez2D1Lm3Jy/D/tZplwpo41HmDSiZJxrjgAhSd92HngCpsmaTFT1XvixePIwbLpqy+EGkO5XvvhzpXCLd+NzOe42AVEkxonhgNUTEvP4uUtZpnnljSQwZSJW9McUjIEzKVWW0/lia7XheunLfP3BAvoMNXGWvUzymOaLV5u587PCaxkDQ9lVmXP358NvgH2AekQ46QJhengFhmMISWdOXRF9wGasNoAAgLDR1j7IJDxo+I6IRAuSBcHde8A0KID10gDDMfx+tHiKRekCiHR4CYXrPkg1dcWA/LA/rTbFAwNDCvM2y5915c156eGzUEICU6QJhlkNbtFuIWUD+7tABwtzlKRCm90jJO9+0l78QNld2y2Uv5iEABKaVVrDscMMnqEZm1xp3Xq8eBRDGoQuEyYNt7DDtJ/KMHpB3PQZS5c+HouP1Tln3n0pVTgMgMPP6SJWfb9T8Nd5E7KSoJNYdl6APDZB8fSCoW1PfLCD+ekDuuQ0gzMtSJ/Ur/+fBBM30x1kABE6WDKpyKo08kRzurZpNDlZUEuPGu9WiAXLDAEjZAFBhjO8DYc6LsaqHBD9eNr3mShWKWKzdywcdjTyRp7m3SmU6eWZnUQHxNwACQjcuV6MM3wfCHBV6rVAhzKgMIqKzPhoGJC8pt23m/l6p3/Qpvpc6JfxQBBkbbTWQi7CVGXcAEGYjNLS2yMoX48B7YeALRB1Xcn8bjOonuJdawjAZnvmG5gCJQXz5OwHIKmGUOMt7FTPVAcaBBCC/oMYxTkJe5F4qr+p/iYpKOngI5HtPgUR1BDXiw80BMrY6gTBP/swHGXkn47J6xvYMAch1Pkdbt10//p2cqAF7LMozIAGeAgmBzmGwOVFG4GpUBxDmFV7bs9AeapLaeUeAjG6gDcirZb5s2FwD3sI2i4EwyNxJzB0BZPQRxa6Sx/CtWkedfV++5YpwYbROq0lcXxE7mf//GkUlH1kNJNDjUIHXgDAHONt3E2rlirH2UgjkX+iYzrJDjJyQ58D/xRi8V4HUujOAcIEpln0CASAAGTIYAtkt3/C+cCFbp800oIAk4Bv29SaQvncIkCc5Z+QyEinZqrgb2hmqhj8LF54gN7mem9DzF60aJ9DKfIuB3EVjPfsaEH6ykHfz0iXln1EFtziRZrKE5bn6QNohRu4FRScDMi0F4hwL5yzj7hQgX0mhw3Q0urgPASJPqj9uCERwQmSjZroH8SxzgBTACdfnmDsFCLNd9LvTUccQSQ0ul3JZ9u8xBLKNe6EsXEyaOp5lDpBc2Mq3xk+tERk0atSoOTPuj/YukO4s+zYSzHqB+6szkjJUIlWW3XfyoL6De6Eclc3lXjzLHCAzoF9o4JVm9hmjzHQEJ85u7UUgKeUCEGlafRPvYmxFeqw3pcprpSvELQeiubC4P0hSu+Z+PMscIM2pw+/L3+uoTiCa1q7MW0CYP7GHuH8Wiao+wl+8hACR1unuXyhdWUVqjZ/rHkowdjpYCQTYd/mndJ4WNTUYl9N1o5a3gKxkuRzGIYjLkf0WkuQo/R6+kQcVYmv8FAjyi+/ldjzLFCDTQebJOzoP6/OAjK3DilGt2iozkWlR3gFyM4FLmBuHWLiTWOwQ8oN0pT2pselc8KofGklxO6JkCpDZdBP6qbIOgwTXKWqHHH9LXO8VIL3bHxTGdiGPd6m2x5LWfXYONVwyclE1pHPygbvxLDOAtFb6oU4FxCcVyPMDO5RKp+QwcXyBN4AwFVyPNAuGEYe0RIBIKdgb5Sv7SG1xCaTTVB8D9Fn5TouA/F3JZL2b3E8WyLHPdvByHbnb+tIrQF4V3RFeunN/XEV49Be9kPHKGlLSPrKTHRiTBsbg+1oDpG5bqcjRU8dHl2ulovNXrYgJRJYA4SO318V036+RuBYvh8R6E5VLbQhNfYRVzy4341m3DWSerLdGeTrPeUmqlaXKpAuXO638+l4Awslrolm1GHH/hHRfaZJd+YEkENyQuEe4odBJ/OAuV2zdagcSHfmulAEUP0cvZ1FeMDFgsrpoDknvlgER19wm8MtBtyBAtotVgK9ISpQ7yb3MHHxHJsrJ6gCyQlpKtq7ejjTJ5Y7NCirQe0qUnH58j9Zzl5O6HMXeAZIM8q8eHoQA6a4ZQdjHCa0MxcdVQ9zMdXAbCEZqdwsymEaXUxtjc7WF7xFe2Cog0jQHn+/wGMLjlpindQhce4VgtHCm5rOYghUgJhFnDRDuy72reR65h2wiO464N1Ysw0Zh3gDyE0h9zy5CgIhJKDfB+urQf+BbqUdy0uYBNa2rBiCPCNI4P1i9BvHRoaTcim66bmUewTC0CoiQ6b7nBZUxxXnpo9GJEE4W4htxcp9xF3YWKl9vXcXtA4mJECSjbN62d0b0Q6lkFWN/IEpwF/crClCGvVQvAHk4VJmobViEiyuex3nuKinmXqUe2RwWDcn11W72BmzoBJk45tfQ3r5ELm5rMLvVzwtAhLTFs6O1I4gYI1mK7J1C8EI4d6pjAXnWito3NMFTb5KILP3UJAGdUohdxDavzP86IiwHspSfHvyO9zcKf0Y2dBI3CZgFLy7Ex95DdpGNqBCwwm2oJbGskD5wBrfjS6riYUpZE2zzq5UKky0HwkdKBgvr1BYjPxBxoc7AcpznrhI/va9/qju+oTnzIfURO2yFdhpNkJr4acznlFs3WA0khd8vdiP//wMtoOqPCB559kKEUiHZCXmRlNPcxEU3O2EiECYgHraTQ+hC78I3D6a3elkN5IwyUKeUQM23eEGogHruZ/GtZHDO7QniQ0AHEmgREKYYLqJybMM7Rm8YWcWunhYDeYJbPLVvgirADpblzES3rTmj44T0CyQJ2A7DMd0iIDApzOVqFof9/qdi78z0xy8ZtQIIl7gwXODRGZkHGS6Uj0OGeXYhYZH6EvptYepZBURYWqcdRqLBLPqzQRip9zdw3zBrgYyrZNndQnhg1WdQ802FhOps1eaNI/HN5AbTA3nOaRWQDbClR9bjRjRjsbbLWlWirEJHOqz22fy1Cekoj3LC8W3t3PiEwfWtAhLdDDbVCuleqeWEpUDWstclP28cTDW5JdhSKYdUW9ERTm+LiHfnI7ayCgj6PXkR44VQyDorgfy7fLE02dQZeuNdRANrmYrHQsLUFL+VRmoAlNz7UQG5z80yrQIyuTZu/4C2cCcUQ4mxEMjhiq7SnrG94QqdsyKPnaEqIK/ozITg5hWAzKZOYTQRSDjiHbbT2rQO9xYfVjOQlIGosSWPH2J8/UwDFY8jhIYyOTejk/7DmlD3WSYCQXcWkna2AyNLzRq+BAQIjCk+JIznzEo1j/LLhLtPUmSYh0yj3U/KTCDIcHFDe+8DGb4J5FMQrdotehqPVao3l51Fuv1LLlUg1+AZIJ7lyrMKSE9kfA7T3Btc5pNANivT6Jt+FK9NVI8fbBdSznv9WGHnBvo+a4RVQHohQMScOWAS1kzyRSDjlN/CaTHgHrZWsx926EFd49J4bhbEswbEWQQkBwEyXevA5/ogkMvSUgS2aJb4o/76F+0G5Y8RRwcub7ORccbVs0APfSwCgrTlytCavd/7HpAvPpby35pKm2IWPq/lUUFsoHVto05Iq5w0rwARvzTNPdww1RogbaStsuYelzJezmFOu7i+l9hCc8oNkK6BPqtjkhe6rGPiRbhz0yhfAyKlL5QoM+UbQ7U8Pi4kthDBbTj5CM12O/OBIi5aAwQJW/WDcQWPNm6qfiBbeV+jxaXj8pXCHzAHXFQuIDexQR2jJgpch/l0uCVAVsC2pOn8OBBQifcpIEt3c7Ppc3cqq5wnvLoHx+OqTiPcKjbH/TSPi4aJB9ssATIbOxEDc1KSfAjIzSPspu0TD4ATFQ5vx3RXbOhInUaiuCy4xDCqB35AFT4xE0gH7P4aMAj8uu8AufnJ0YHI8RarNg7GniS2Va+VXjSTgJgefVqYFUDgmQCPKkFgl2GWg7djWVUy+jj+ZLdK3ROKwzgvy7Gc7hHra9NkzJkIJCLfhcsIi37Rw019LQQSdrwEf4TYIv1T2mLc2koEbBxLyvcwFUgkYUdyGFH5yCeBXH6fcKTbonP6N/LLLC7QPgYqwhFX/UDGQLsO9JFRIJWycZLPAQmbVEo6Yu95g5NXQzjFBBfQPgkuAEWXvgLpYRqQDJh60YQ0mg11+haQvSP/SsIxONnoZAo/0pIXgsBsoQ+cOm26A2QGTcQfXW9aAA7EGbDNAyBt9YBM85zG+AU/VBJPoNxz1fB+fqV3EP3zoMHpiDEJCGlDxengZKRGAeSHxEe7D6SfHpApHtJY2vXxIp0TQU9/ZdgCvwOpww07pTW0s94zCcgGgh8KorrBPbAROL01IvpApoXrAHF4cmLJV0dPJ+gd0NpiEkUjF92NPiAnETryzAFCCBC+oZst6fwLnDAjBXLy0ghAMN/Ce6g8I5w8uPloxSD983LZitdorIFmbn2/OEHmVFdHmAIEuyrl2pegBs4MTIJZdGOwdknmDlc+YdEnpp++h2LzvC+OX9mbvZQ/NWfCkOy947penZVcsqiBAQw29Ldfqb7uQqRoiTtATiFnqD2dYQaQKdplctfgGXfH8L/E6XCbzLu03/i6c6ap1utAIM+E6wAh9+LHSxNa7GnZv0qKWm5KYKkkdO7xFKpYYaowIDR259StkA+RKaP4YgMgNSiAuOI3INoJb70DPoV4cl4SdNhjV6BfjrJv+V/QsToEIK40JxmIqxs5m+VAcijrjoQmf06h1tyYPspObA+sOXGyyfeUzsgYVabm6p49inPJQKJogFR9JbNScyJb12kdue71YVnIuXu7dBY1hiAHIwUPnSGqsSDyJTEIFr+cIQFxJfaIIwJxxeeQ0wY6/15EjWPR2qdotPotJgd2Mh2QSMyt8WQgBXRASNIsR9fgcQahB6rGNvvy7iWJjWRT8I26DBmIy1Uzcf6OdXgg3MYFa1J7EZ7bu80nNEy6vLl5FZ1W/6L96Im0nRbmdOURRCCxTs+BBCeeMD7mMy6VuJCidmAx2eyV5SUSEAOX+cGuW9rrDeaVpVvaDKEeCcbcq5E+tPcGae+tQwRyg/EISLD/B7NrBdCFRJaP6Yhtoq2fdoKgW021BCsRmamawpq6CYFMSmHXnRUYKg3aLz7a5rUUxlfEj2ZL6jzSEfeRfjGTc6Pc8syiTq5BTzt2NR6RMx2HM66GRkA4RltIs7v6+APdZw7f1/RSenr6peTHD81ccHgC41sCp96nWvTMkNYXmqcFrl69ulvbqe025DK2EMLvQbY6vC8wl6rYVof3BcxVNM601eF9ed0wHmyLpTLMvS0abaluUU6xDQ6wteEDEk/j6NpimdTApBra4kW54GFmui3VJPIq8pr2COILoqRBtLKV4QPilH8gncJsbXhfwuXsnA8zbG14Xwpkp3CsPYB4X8KC5KytJUm2OrwoGdEMs75Hqjy/XXuU01aKb7ge/JLpe5fbKvEZ59w1tlV9WyFeF35ZbO1jWcMuxNS1teEDEhEQEHAt5P/wg/0PzdRSPYf2VisAAAAASUVORK5CYII=";
/*! js-cookie v3.0.5 | MIT */
function g(s) {
  for (var o = 1; o < arguments.length; o++) {
    var d = arguments[o];
    for (var l in d)
      s[l] = d[l];
  }
  return s;
}
var k = {
  read: function(s) {
    return s[0] === '"' && (s = s.slice(1, -1)), s.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(s) {
    return encodeURIComponent(s).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function w(s, o) {
  function d(a, i, r) {
    if (!(typeof document > "u")) {
      r = g({}, o, r), typeof r.expires == "number" && (r.expires = new Date(Date.now() + r.expires * 864e5)), r.expires && (r.expires = r.expires.toUTCString()), a = encodeURIComponent(a).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var t = "";
      for (var n in r)
        r[n] && (t += "; " + n, r[n] !== !0 && (t += "=" + r[n].split(";")[0]));
      return document.cookie = a + "=" + s.write(i, a) + t;
    }
  }
  function l(a) {
    if (!(typeof document > "u" || arguments.length && !a)) {
      for (var i = document.cookie ? document.cookie.split("; ") : [], r = {}, t = 0; t < i.length; t++) {
        var n = i[t].split("="), m = n.slice(1).join("=");
        try {
          var u = decodeURIComponent(n[0]);
          if (r[u] = s.read(m, u), a === u)
            break;
        } catch {
        }
      }
      return a ? r[a] : r;
    }
  }
  return Object.create(
    {
      set: d,
      get: l,
      remove: function(a, i) {
        d(
          a,
          "",
          g({}, i, {
            expires: -1
          })
        );
      },
      withAttributes: function(a) {
        return w(this.converter, g({}, this.attributes, a));
      },
      withConverter: function(a) {
        return w(g({}, this.converter, a), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(o) },
      converter: { value: Object.freeze(s) }
    }
  );
}
var C = w(k, { path: "/" });
function M({ menuData: s, isTouchEnabled: o }) {
  const [d, l] = A(null), [a, i] = A("closed"), r = (n) => {
    n === "standard" ? a === "closed" ? (i("standard"), l(null)) : a === "standard" ? i("closed") : a === "account" && (i("standard"), l(null)) : n === "account" && (a === "closed" ? (i("account"), l("myAccount")) : a === "account" ? (i("closed"), l(null)) : a === "standard" && (i("account"), l("myAccount")));
  }, t = C.get("isLoggedIn") === "true";
  return /* @__PURE__ */ c(v, { children: [
    /* @__PURE__ */ c(
      "div",
      {
        className: `ajb-main-nav-wrapper-menu-wrapper ${a !== "closed" ? "is-active" : ""}`,
        children: [
          /* @__PURE__ */ c("div", { className: "leading-group", children: [
            /* @__PURE__ */ e("a", { href: "/", rel: "home", children: /* @__PURE__ */ e(
              "img",
              {
                src: S,
                alt: "AJ Bell logo - Return to home page",
                className: "logo-img"
              }
            ) }),
            /* @__PURE__ */ e(
              "nav",
              {
                className: `ajb-main-nav ${o ? "is-touch-enabled" : ""} ${a === "standard" ? "show" : ""}`,
                "aria-expanded": a === "standard",
                children: /* @__PURE__ */ e("div", { className: "ajb-main-nav-list-wrapper", children: /* @__PURE__ */ e("ul", { children: s.mainMenu.map((n, m) => /* @__PURE__ */ e(
                  L,
                  {
                    item: n,
                    isTouchEnabled: o,
                    setActiveSubmenu: l,
                    activeSubmenu: d,
                    isLoggedIn: t
                  },
                  m
                )) }) })
              }
            )
          ] }),
          /* @__PURE__ */ e("div", { className: "trailing-group", children: /* @__PURE__ */ e("nav", { className: "ajb-main-nav-trailing", "aria-expanded": "false", children: /* @__PURE__ */ e("ul", { children: s.trailingMenu.map(
            (n, m) => {
              if (n.submenu === "mobile-menu-account-trigger") {
                if (t)
                  return /* @__PURE__ */ c(
                    "li",
                    {
                      className: n.submenu ? `${n.submenu}-wrapper` : "",
                      children: [
                        " ",
                        /* @__PURE__ */ e(
                          y,
                          {
                            label: n.label,
                            submenu: n.submenu,
                            isActive: a === (n.submenu === "mobile-menu-trigger" ? "standard" : "account"),
                            onClick: () => r(
                              n.submenu === "mobile-menu-trigger" ? "standard" : "account"
                            )
                          }
                        )
                      ]
                    },
                    m
                  );
              } else return n.submenu === "mobile-menu-trigger" ? /* @__PURE__ */ e(
                "li",
                {
                  className: n.submenu ? `${n.submenu}-wrapper` : "",
                  children: n.hasSubmenu && /* @__PURE__ */ e(
                    y,
                    {
                      label: n.label,
                      submenu: n.submenu,
                      isActive: a === (n.submenu === "mobile-menu-trigger" ? "standard" : "account"),
                      onClick: () => r(
                        n.submenu === "mobile-menu-trigger" ? "standard" : "account"
                      )
                    }
                  )
                },
                m
              ) : /* @__PURE__ */ e("li", { children: /* @__PURE__ */ c("a", { href: n.href, className: "ajb-main-nav-btn-login", children: [
                /* @__PURE__ */ e(
                  "svg",
                  {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 512 512",
                    "aria-hidden": "true",
                    focusable: "false",
                    role: "img",
                    children: /* @__PURE__ */ e(
                      "path",
                      {
                        fill: "currentcolor",
                        d: "M399 384.2C376.9 345.8 335.4 320 288 320l-64 0c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"
                      }
                    )
                  }
                ),
                t ? "Logout" : "Login"
              ] }) }, m);
            }
          ) }) }) })
        ]
      }
    ),
    /* @__PURE__ */ c(
      "div",
      {
        className: `ajb-main-nav-submenu-container ${o ? "is-touch-enabled" : ""} ${d ? "show" : ""} ${d === "myAccount" ? "is-right" : ""}`,
        "aria-hidden": !d,
        onMouseLeave: () => {
          l(null);
        },
        children: [
          /* @__PURE__ */ e("div", { className: "ajb-main-menu-pointer", children: /* @__PURE__ */ e(
            "svg",
            {
              className: "ajb-main-menu-pointer-svg",
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 512 512",
              "aria-hidden": "true",
              focusable: "false",
              role: "img",
              children: /* @__PURE__ */ e("path", { d: "M290.5 51.8C283.3 39.5 270.2 32 256 32s-27.3 7.5-34.5 19.8l-216 368c-7.3 12.4-7.3 27.7-.2 40.1S25.7 480 40 480l432 0c14.3 0 27.6-7.7 34.7-20.1s7-27.8-.2-40.1l-216-368z" })
            }
          ) }),
          s.mainMenu.map(
            (n) => n.hasSubmenu ? /* @__PURE__ */ e(
              x,
              {
                submenuId: n.submenu,
                items: n.items,
                isActive: d === n.submenu,
                isTouchEnabled: o,
                setActiveSubmenu: l
              },
              n.submenu
            ) : null
          )
        ]
      }
    )
  ] });
}
const D = {
  mainMenu: [
    {
      label: "Investing",
      submenu: "investing",
      hasSubmenu: !0,
      items: [
        {
          category: "Our accounts",
          submenuId: "ourAccountsMenu",
          links: [
            {
              title: "Stocks & shares ISA",
              href: "/isa/stocks-shares-isa",
              desc: "Invest up to £20,000 each tax year, with tax-free growth"
            },
            {
              title: "Self-invested personal pension (SIPP)",
              href: "/pensions/sipp",
              desc: "Plan for retirement with our Which? recommended pension account"
            },
            {
              title: "Ready-made pension",
              href: "/pensions/ready-made-pension",
              desc: "Our low-cost, hassle-free ready-made pension that's managed for you"
            },
            {
              title: "Dealing account",
              href: "/dealing-account",
              desc: "Invest your money your way with our general investment account"
            },
            {
              title: "Lifetime ISA",
              href: "/isa/lifetime-isa",
              desc: "The ISA designed to help you save for your first home or retirement"
            },
            {
              title: "Junior ISA",
              href: "/isa/junior-isa",
              desc: "Invest for the little one in your life with a Junior ISA"
            },
            {
              title: "Cash savings hub",
              href: "/isa/junior-isa",
              desc: "Access savings interest rates you won't find on the high street"
            }
          ],
          features: [
            {
              title: "Charges & rates",
              href: "/charges-and-rates",
              desc: "Understand what our charges and rates mean for you",
              icon: `<svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 384 512"
                                aria-hidden="true" focusable="false" role="img"
                              >
                                <path d="M352 160l0 288c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-288 320 0zm0-32L32 128l0-64c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 64zm32 0l0-64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64l0 64 0 16 0 16L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288 0-16 0-16zM72 224a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm72-72a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm72-72a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM264 416a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM80 400c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 400z"></path>
                              </svg>`
            },
            {
              title: "All accounts",
              href: "/investment/accounts",
              desc: "All our accounts under one roof. Find an account that suits you",
              icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" aria-hidden="true" focusable="false" role="img">
													<path d="M320 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM32 480l384 0c-1.2-79.7-66.2-144-146.3-144l-91.4 0c-80 0-145 64.3-146.3 144zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3z"></path>
												</svg>`
            }
          ]
        },
        {
          category: "Choose your investments",
          submenuId: "chooseInvestmentsMenu",
          links: [
            {
              title: "Shares",
              href: "/investment/shares",
              desc: "Find, research, buy and sell shares from across the globe"
            },
            {
              title: "Funds",
              href: "/investment/funds",
              desc: "Explore the universe of funds we have available to invest in"
            },
            {
              title: "ETFs",
              href: "/investment/exchange-traded-funds",
              desc: "Choose funds from a broad range of indices and benchmarks"
            },
            {
              title: "Investment trusts",
              href: "/investment/investment-trusts",
              desc: "From income to growth, explore our range of investment trusts"
            },
            {
              title: "Bonds & gilts",
              href: "/investment/bonds",
              desc: "Our full range of bonds and securities for low-volatility investing"
            },
            {
              title: "International dealing",
              href: "/investment/international",
              desc: "All the international markets you can invest in, and how to do it"
            }
          ],
          features: [
            {
              title: "See all investments",
              href: "/investment",
              desc: "Our full range of investments, so you can build the ideal portfolio",
              icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" aria-hidden="true" focusable="false" role="img">
													<path d="M170.1 33.1c3.3-1.3 6.9-1.5 10.3-.5L399.1 95.1l144-57.6c15.8-6.3 32.9 5.3 32.9 22.3l0 334.8c0 9.8-6 18.6-15.1 22.3l-155 62c-3.3 1.3-6.9 1.5-10.3 .5L176.9 416.9l-144 57.6C17.1 480.8 0 469.2 0 452.2L0 117.4c0-9.8 6-18.6 15.1-22.3l155-62zM32 122.8l0 317.5 128-51.2 0-317.5L32 122.8zm352 320l0-318.7L192 69.2l0 318.7 192 54.9zm32-2.4l128-51.2 0-317.5L416 122.8l0 317.5z"></path>
												</svg>`
            },
            {
              title: "Investment ideas",
              href: "/investment/ideas",
              desc: "Unsure where to invest? Let us help you",
              icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" aria-hidden="true" focusable="false" role="img">
													<path d="M170.1 33.1c3.3-1.3 6.9-1.5 10.3-.5L399.1 95.1l144-57.6c15.8-6.3 32.9 5.3 32.9 22.3l0 334.8c0 9.8-6 18.6-15.1 22.3l-155 62c-3.3 1.3-6.9 1.5-10.3 .5L176.9 416.9l-144 57.6C17.1 480.8 0 469.2 0 452.2L0 117.4c0-9.8 6-18.6 15.1-22.3l155-62zM32 122.8l0 317.5 128-51.2 0-317.5L32 122.8zm352 320l0-318.7L192 69.2l0 318.7 192 54.9zm32-2.4l128-51.2 0-317.5L416 122.8l0 317.5z"></path>
												</svg>`
            }
          ]
        }
      ]
    },
    {
      label: "ISAs",
      submenu: "isas",
      hasSubmenu: !0,
      items: [
        {
          category: "ISA accounts",
          submenuId: "isaAccountsMenu",
          links: [
            {
              title: "Stocks & shares ISA",
              href: "/isa/stocks-shares-isa",
              desc: "Invest up to £20,000 each tax year, with growth tax-free"
            },
            {
              title: "Lifetime ISA",
              href: "/isa/lifetime-isa",
              desc: "The ISA designed to help you save for your first home or retirement"
            },
            {
              title: "Junior ISA",
              href: "/isa/junior-isa",
              desc: "Invest for the little one in your life with a Junior ISA"
            },
            {
              title: "All ISA accounts",
              href: "/isa",
              desc: "Explore and compare all our ISA accounts"
            }
          ]
        },
        {
          category: "Managing an ISA",
          submenuId: "managingIsaMenu",
          links: [
            {
              title: "ISA allowances",
              href: "/isa/isa-allowances",
              desc: "Understand how to make the most of your tax-free allowancee"
            },
            {
              title: "Transfer an ISA",
              href: "/isa/transfer",
              desc: "Move your money over to one of our low-cost, easy-to-manage ISAs"
            },
            {
              title: "Multiple ISAs",
              href: "/isa/multiple-accounts",
              desc: "Learn more about how to split your annual allowance"
            },
            {
              title: "ISA essentials",
              href: "/learn/investing-essentials",
              desc: "Everything you need to know about saving and investing in ISAs"
            },
            {
              title: "What is an ISA?",
              href: "/isa/stocks-shares-isa/what-is",
              desc: "Understand the different types of ISAs, the benefits and how to start"
            }
          ]
        }
      ]
    },
    {
      label: "Pensions",
      submenu: "pensions",
      hasSubmenu: !0,
      items: [
        {
          category: "Pension accounts",
          submenuId: "pensionAccountsMenu",
          links: [
            {
              title: "Self-invested personal pension (SIPP)",
              href: "/pensions/sipp",
              desc: "Plan for retirement with our Which? recommended pension account"
            },
            {
              title: "Ready-made pension",
              href: "/pensions/ready-made-pension",
              desc: "Our low-cost, hassle-free ready-made pension that's managed for you"
            },
            {
              title: "Junior SIPP",
              href: "/pensions/junior-sipp",
              desc: "Starting building a pension for the little one in your life"
            },
            {
              title: "All pension accounts",
              href: "/pensions",
              desc: "Build a pension that's perfect for you with our accounts and guides"
            }
          ]
        },
        {
          category: "Saving for retirement",
          submenuId: "savingRetirementMenu",
          links: [
            {
              title: "Find my pensions",
              href: "/pensions/find-my-pensions",
              desc: "Our FREE service that tracks down your lost workplace pensions"
            },
            {
              title: "Pension consolidation",
              href: "/pensions/consolidating-pensions",
              desc: "Streamline your retirement savings with our consolidation service"
            },
            {
              title: "Transfer a pension",
              href: "/transfer",
              desc: "Transfer your money to the seven-time Which? recommended platform"
            },
            {
              title: "Pension builder fund",
              href: "/pensions/builder",
              desc: "The classic, balanced fund designed for long-term, stable growth"
            },
            {
              title: "Pension essentials",
              href: "/pensions/learn",
              desc: "A library of guides to help you build a pension that works for you"
            },
            {
              title: "What is a SIPP?",
              href: "/pensions/sipp/what-is",
              desc: "Understand the finer points of opening and managing a SIPP"
            }
          ]
        },
        {
          category: "Approaching retirement",
          submenuId: "approachingRetirementMenu",
          links: [
            {
              title: "Accessing your pension",
              href: "/retirement",
              desc: "Your pension options explained, to get you ready for retirement"
            },
            {
              title: "Drawdown",
              href: "/pensions/drawdown",
              desc: "Unlock flexible retirement income and control your finances"
            },
            {
              title: "Investing in retirement",
              href: "/pensions/investing-in-later-life",
              desc: "Strategies to help you grow your wealth in retirement"
            }
          ]
        }
      ]
    },
    {
      label: "News & Insights",
      href: "/news",
      hasSubmenu: !1
    },
    {
      label: "Help & Education",
      submenu: "help",
      hasSubmenu: !0,
      items: [
        {
          category: "Learn to invest",
          submenuId: "learnInvestMenu",
          links: [
            {
              title: "Learn hub",
              href: "/learn",
              desc: "A wealth of resources to help inform your investment decisions"
            },
            {
              title: "Investing essentials",
              href: "/learn/investing-essentials",
              desc: "Master the fundamentals of investing with our collection of guides"
            },
            {
              title: "Building your portfolio",
              href: "/learn/building-your-portfolio",
              desc: "Our experts share tips and insight on crafting your ideal portfolio"
            },
            {
              title: "Jargon buster",
              href: "/learn/jargon",
              desc: "Demystify the world of financial terminology the easy way"
            },
            {
              title: "Money & markets podcast",
              href: "/learn/podcast",
              desc: "Join our experts as they debate and dissect the latest stories"
            },
            {
              title: "Money matters",
              href: "https://www.ajbellmoneymatters.co.uk/",
              desc: "Our dedicated space to help women feel good, investing"
            }
          ]
        },
        {
          category: "Support",
          submenuId: "supportMenu",
          links: [
            {
              title: "Contact us",
              href: "/can-we-help",
              desc: "Our support team are on hand to help you whenever you need"
            },
            {
              title: "FAQs",
              href: "/faq",
              desc: "Find answers to common questions instantly with our FAQs"
            },
            {
              title: "Security centre",
              href: "/security-centre",
              desc: "How we keep you, your account, and your investments safe"
            }
          ]
        }
      ]
    },
    {
      label: "New to AJ Bell",
      submenu: "newToAjBell",
      hasSubmenu: !0,
      items: [
        {
          category: "About us",
          desc: "Learn why over 500,000 customers invest their money with us",
          href: "/about-us"
        },
        {
          category: "New to investing",
          desc: "Never invested before? Our Dodl accounts may be right for you",
          href: "/new-to-investing"
        },
        {
          category: "Our awards",
          desc: "We're one of the most awarded platforms around. See what we've won",
          href: "/awards"
        },
        {
          category: "Transfer to AJ Bell",
          desc: "Looking to move to us? We'll do all the heavy lifting for you",
          href: "/transfer"
        },
        {
          category: "Special offers",
          desc: "Don’t miss our latest transfer and referral offers",
          href: "/investment/accounts/offers"
        },
        {
          category: "AJ Bell app",
          desc: "Manage your money on the move, with the AJ Bell app",
          href: "/investment/accounts/features"
        }
      ]
    },
    {
      label: "Account",
      submenu: "myAccount",
      hasSubmenu: !0,
      isLastItem: !0,
      items: [
        {
          category: "Portfolio & dealing",
          submenuId: "portfolioDealingMenu",
          links: [
            {
              title: "Account overview",
              href: "/platform/overview",
              desc: "Your AJ Bell accounts summary"
            },
            {
              title: "Portfolio overview",
              href: "/platform/portfolio",
              desc: "Check your porfolio details and performance"
            },
            {
              title: "Buy and sell",
              href: "/platform/trade",
              desc: "Search for an investment by name, ticker, or sedol"
            },
            {
              title: "Active orders",
              href: "/platform/orders",
              desc: "See your upcoming investments"
            },
            {
              title: "Regular investments",
              href: "/platform/regularinvestments",
              desc: "Set up monthly investments starting at £25 per month"
            },
            {
              title: "Dividends & income",
              href: "/platform/dividends-and-income",
              desc: "See all income, dividends, and cash payments from your investments"
            },
            {
              title: "Find my pensions",
              href: "/platform/pensionfinder",
              desc: "Looking for old pensions? We'll find them for free"
            }
          ]
        },
        {
          category: "Manage payments",
          submenuId: "managePaymentsMenu",
          links: [
            {
              title: "Single payment",
              href: "/platform/singlepayment",
              desc: "Add money to your account with a one-off payment"
            },
            {
              title: "Regular payment",
              href: "/platform/regularpayments",
              desc: "Set up a direct debit or amend or cancel an existing one"
            },
            {
              title: "Withdrawals",
              href: "/platform/withdrawcash",
              desc: "Take money out of your AJ Bell account"
            },
            {
              title: "Move cash between accounts",
              href: "/platform/movecash",
              desc: "Switch cash between your AJ Bell accounts"
            },
            {
              title: "Manage my pension",
              href: "/platform/manage-my-pension",
              desc: "Review and update your pension details and contributions"
            }
          ]
        },
        {
          category: "Documents and statements",
          submenuId: "documentsStatementsMenu",
          links: [
            {
              title: "Transaction history",
              href: "/platform/history",
              desc: "See the full history of your account"
            },
            {
              title: "Cash statement",
              href: "/platform/statements",
              desc: "View and download your cash statements and balance"
            },
            {
              title: "Corporate actions",
              href: "/platform/corporateactions",
              desc: "See any actions or corporate updates on specific investments"
            },
            {
              title: "Documents",
              href: "/platform/documents",
              desc: "View tax summaries, quarterly statements and more"
            },
            {
              title: "Voting instructions",
              href: "/platform/voting-instructions",
              desc: "Vote in company AGMs or special events"
            }
          ]
        },
        {
          category: "My account management",
          submenuId: "myAccountManagementMenu",
          links: [
            {
              title: "Transfer an account",
              href: "/platform/transfers",
              desc: "Choose the type of account you'd like to move to us"
            },
            {
              title: "Update my details",
              href: "/platform/admin/updatedetails",
              desc: "Change contact details, banking details, and preferences"
            },
            {
              title: "Security settings",
              href: "/myaccount/security",
              desc: "Change your password and set up two-factor authentication"
            }
          ]
        }
      ]
    }
  ],
  trailingMenu: [
    { label: "Login", href: "/login", icon: "user" },
    {
      label: "Account",
      submenu: "mobile-menu-account-trigger",
      hasSubmenu: !0
    },
    { label: "Menu", submenu: "mobile-menu-trigger", hasSubmenu: !0 }
  ]
}, P = ({ menuData: s }) => {
  const [o, d] = A(!1), [l, a] = A(D);
  return b(() => {
    const i = () => {
      const r = "ontouchstart" in window || navigator.maxTouchPoints > 0, t = window.innerWidth < 1024 || window.innerHeight <= 720;
      d(r || t);
    };
    return i(), window.addEventListener("resize", i), () => window.removeEventListener("resize", i);
  }, []), b(() => {
    s && a(s);
  }, [s]), /* @__PURE__ */ c(v, { children: [
    /* @__PURE__ */ e(
      "div",
      {
        className: `ajb-main-nav-wrapper ${o ? "is-touch-enabled" : ""}`,
        children: /* @__PURE__ */ e(M, { isTouchEnabled: o, menuData: l })
      }
    ),
    /* @__PURE__ */ e(
      "div",
      {
        className: `ajb-main-menu-back-cover ${o ? "is-touch-enabled" : ""}`
      }
    )
  ] });
}, T = ({ menuData: s }) => /* @__PURE__ */ e("div", { className: "outer-nav", children: /* @__PURE__ */ e(P, { menuData: s }) });
export {
  T as MegaNav
};
